import {
  ReplacementConfig,
  ReplacementValues,
} from '../../config/replacementConfig'
import { processReplacement } from './processReplacement'

// type RequireAtLeastOne<T, Keys extends keyof T = keyof T> = Pick<
//   T,
//   Exclude<keyof T, Keys>
// > &
//   {
//     [K in Keys]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<Keys, K>>>
//   }[Keys]

export type ReplaceList = Record<string, ReplacementValues>
export interface ReplaceInfo {
  type: 'link' | 'variable'
  text?: string
  key?: string
  to?: string
}

//type ReplaceInfo = RequireAtLeastOne<ReplaceInfoFields, 'key' | 'text'>

export const substituteValue = (
  baseString: string,
  values: Record<string, string>,
  replacementData: Record<string, ReplaceInfo>
) => {
  const reg = new RegExp('{(.*?)}', 'g')
  const replacedValues = baseString.match(reg)

  if (!replacedValues) {
    return baseString
  }

  const newString = baseString
    .split(reg)
    .map((subStr: string) => {
      const check = Object.values(ReplacementValues).includes(
        subStr as ReplacementValues
      )
      if (!check) {
        return subStr
      }

      switch (ReplacementConfig[subStr as ReplacementValues]) {
        // case ContentVariants.text:
        //   return String(processReplacement(subStr, values, replacementData))
        default:
          return String(processReplacement(subStr, values, replacementData))
      }
    })
    .join('')

  return newString
}
